// ============================================================
// 客户端 - 鉴权接口
// ============================================================
import { http } from "@shared/utils/request";
import type { LoginParams, LoginResult } from "@shared/types/user";

export function login(params: LoginParams): Promise<LoginResult> {
    return http.post<LoginResult>("/customer/login", {
        username: params.username,
        password: params.password,
    });
}

export function logout(): Promise<void> {
    return http.post<void>("/customer/logout");
}

/** Admin 跳转客户端：一次性 ticket 换 JWT（不记登录日志） */
export function exchangeJumpTicket(ticket: string): Promise<LoginResult> {
    return http.post<LoginResult>("/customer/auth/exchangeJumpTicket", { ticket }, { skipUnauthorizedHandler: true });
}

export interface CheckInviteCodeResult {
    valid: boolean;
    channelId?: string | null;
}

export function checkInviteCode(inviteCode: string): Promise<CheckInviteCodeResult> {
    return http.post<CheckInviteCodeResult>("/customer/auth/checkInviteCode", { inviteCode });
}

export interface RegisterPayload {
    applicantName: string;
    tel: string;
    corpName: string;
    corpShortName: string;
    inviteCode?: string;
    contactName?: string;
    contactTelephone?: string;
    country?: string;
    province?: string;
    city?: string;
    district?: string;
    detailAddress?: string;
    weixin?: string;
    email?: string;
}

export function register(data: RegisterPayload): Promise<void> {
    return http.post<void>("/customer/auth/register", data);
}
